import { createStore, combineReducers, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension'
import reducers from '../reducers';
import thunk from 'redux-thunk'

const middleware = [thunk]

export default function configureStore() {
    return createStore(
        combineReducers({
            ...reducers
        }),
        {},
        composeWithDevTools(applyMiddleware(...middleware))
    );
}